// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var appShellNarrowMaxPx = 1479;

function isDrawerViewport(viewportWidth) {
  return viewportWidth <= appShellNarrowMaxPx;
}

function navModeForViewport(viewportWidth) {
  if (viewportWidth <= appShellNarrowMaxPx) {
    return "drawer";
  } else {
    return "rail";
  }
}

function setNavMode(root, viewportWidth) {
  var mode = navModeForViewport(viewportWidth);
  root.setAttribute("data-nav-mode", mode);
  document.documentElement.setAttribute("data-nav-mode", mode);
}

function closeNavFlyout(flyout) {
  flyout.removeAttribute("data-hub-games-open");
  var trigger = flyout.querySelector("[data-nav-flyout-trigger]");
  if (!(trigger == null)) {
    trigger.setAttribute("aria-expanded", "false");
  }
  var panel = flyout.querySelector("[data-hub-games-hover-panel]");
  if (!(panel == null)) {
    panel.setAttribute("aria-hidden", "true");
    return ;
  }
  
}

function closeNavFlyouts(root) {
  Belt_Array.forEach(Array.from(root.querySelectorAll("[data-hub-games-flyout]")), closeNavFlyout);
}

function closeTopNavFlyout(root) {
  var open_ = root.querySelector("[data-hub-games-flyout][data-hub-games-open=\"true\"]");
  if (open_ == null) {
    return false;
  } else {
    closeNavFlyout(open_);
    return true;
  }
}

function setOverlayHidden(overlay, hidden) {
  if (hidden) {
    DomEl$GameDataCore.addClass(overlay, "hidden");
    overlay.setAttribute("aria-hidden", "true");
  } else {
    DomEl$GameDataCore.removeClass(overlay, "hidden");
    overlay.setAttribute("aria-hidden", "false");
  }
}

function setOpen(root, open_, viewportWidth) {
  var panel = root.querySelector("[data-app-nav-panel]");
  if (panel == null) {
    return ;
  }
  var overlay = root.querySelector("[data-app-nav-overlay]");
  var btn = document.getElementById("mobile-nav-open-btn");
  var drawer = viewportWidth <= appShellNarrowMaxPx;
  if (drawer) {
    if (open_) {
      panel.setAttribute("data-app-nav-open", "true");
      if (!(overlay == null)) {
        setOverlayHidden(overlay, false);
      }
      DomEl$GameDataCore.addClass(document.body, "overflow-hidden");
      if (!(btn == null)) {
        btn.setAttribute("aria-expanded", "true");
        return ;
      } else {
        return ;
      }
    } else {
      panel.removeAttribute("data-app-nav-open");
      if (!(overlay == null)) {
        setOverlayHidden(overlay, true);
      }
      DomEl$GameDataCore.removeClass(document.body, "overflow-hidden");
      if (!(btn == null)) {
        btn.setAttribute("aria-expanded", "false");
      }
      return closeNavFlyouts(root);
    }
  } else {
    panel.removeAttribute("data-app-nav-open");
    if (!(overlay == null)) {
      setOverlayHidden(overlay, true);
    }
    DomEl$GameDataCore.removeClass(document.body, "overflow-hidden");
    if (!(btn == null)) {
      btn.setAttribute("aria-expanded", "false");
      return ;
    } else {
      return ;
    }
  }
}

function mounted() {
  var self = this ;
  var root = self.el;
  if (!DomEl$GameDataCore.isHtmlElement(root)) {
    return ;
  }
  self._appNavOpen = false;
  setNavMode(root, window.innerWidth);
  setOpen(root, false, window.innerWidth);
  var openDrawer = function () {
    self._appNavOpen = true;
    setOpen(root, true, window.innerWidth);
  };
  var closeDrawer = function () {
    self._appNavOpen = false;
    setOpen(root, false, window.innerWidth);
  };
  var btn = document.getElementById("mobile-nav-open-btn");
  var openBtnOff = !(btn == null) ? DomEl$GameDataCore.on(btn, "click", (function (param) {
            openDrawer();
          })) : undefined;
  var overlay = root.querySelector("[data-app-nav-overlay]");
  var overlayOff = !(overlay == null) ? DomEl$GameDataCore.on(overlay, "click", (function (param) {
            closeDrawer();
          })) : undefined;
  var closeBtn = root.querySelector("[data-app-nav-close]");
  var closeOff = !(closeBtn == null) ? DomEl$GameDataCore.on(closeBtn, "click", (function (param) {
            closeDrawer();
          })) : undefined;
  var onKey = function ($$event) {
    if ($$event.key === "Escape") {
      if (closeTopNavFlyout(root)) {
        $$event.preventDefault();
        return ;
      } else {
        return closeDrawer();
      }
    }
    
  };
  document.addEventListener("keydown", onKey);
  var onPageNav = function (param) {
    closeDrawer();
  };
  window.addEventListener("phx:page-loading-start", onPageNav, {});
  var onProxyClick = function ($$event) {
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var node = target.closest("[data-app-nav-proxy-click], [data-app-nav-close-on-click]");
    if (node == null) {
      return ;
    }
    if (!root.contains(node)) {
      return ;
    }
    if (Caml_option.nullable_to_opt(node.getAttribute("data-app-nav-proxy-click")) === undefined) {
      if (Caml_option.nullable_to_opt(node.getAttribute("data-app-nav-close-on-click")) !== undefined) {
        queueMicrotask(function () {
              closeDrawer();
            });
        return ;
      } else {
        return ;
      }
    }
    $$event.preventDefault();
    var id = node.getAttribute("data-app-nav-proxy-click");
    if (id == null) {
      return ;
    }
    var el = document.getElementById(id);
    if (!(el == null)) {
      el.click();
      return closeDrawer();
    }
    
  };
  var proxyOff = DomEl$GameDataCore.on(root, "click", onProxyClick);
  var onResize = function (param) {
    var wasDrawer = DomEl$GameDataCore.data(root, "nav-mode") === "drawer";
    setNavMode(root, window.innerWidth);
    var viewportWidth = window.innerWidth;
    var nowDrawer = viewportWidth <= appShellNarrowMaxPx;
    if (wasDrawer !== nowDrawer) {
      self._appNavOpen = false;
      setOpen(root, false, window.innerWidth);
      return closeNavFlyouts(root);
    }
    
  };
  window.addEventListener("resize", onResize, {});
  self._appNavCleanup = (function () {
      if (openBtnOff !== undefined) {
        openBtnOff();
      }
      if (overlayOff !== undefined) {
        overlayOff();
      }
      if (closeOff !== undefined) {
        closeOff();
      }
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("phx:page-loading-start", onPageNav);
      window.removeEventListener("resize", onResize);
      proxyOff();
      DomEl$GameDataCore.removeClass(document.body, "overflow-hidden");
      document.documentElement.removeAttribute("data-nav-mode");
    });
}

function updated() {
  var self = this ;
  if (DomEl$GameDataCore.isHtmlElement(self.el)) {
    return setOpen(self.el, self._appNavOpen, window.innerWidth);
  }
  
}

function destroyed() {
  var self = this ;
  var run = self._appNavCleanup;
  if (run !== undefined) {
    run();
  }
  self._appNavCleanup = undefined;
}

var AppNav = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var appShellMdMinPx = 1480;

export {
  appShellMdMinPx ,
  appShellNarrowMaxPx ,
  isDrawerViewport ,
  navModeForViewport ,
  setNavMode ,
  closeNavFlyout ,
  closeNavFlyouts ,
  closeTopNavFlyout ,
  setOverlayHidden ,
  setOpen ,
  mounted ,
  updated ,
  destroyed ,
  AppNav ,
}
/* mounted Not a pure module */
